module.exports = __webpack_public_path__ + "static/img/fiscaliageneraldelestado.4f7162b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fiscaliageneraldelestado.png
// module id = kAnq
// module chunks = 9